import { getMessages } from 'app/store/constants';

export const CARD_TAG_ADD = getMessages().getText('card_form_tag_add');
export const CARD_TAG_MODAL_CANCEL = getMessages().getText('common.cancel');
export const CARD_TAG_MODAL_REMOVE = getMessages().getText('common.remove');
